module.exports = __webpack_public_path__ + "img/munna-bhai-759@2x.7ab8d6f1.png";